import React from "react";

const MyLines = ({ type }) => {
  return (
    <hr
      style={{
        borderTop: `${type === "double" ? "5px" : "3px"} ${
          type === "dashed" ? "dashed" : type === "double" ? "double" : "solid"
        } #00abff`,
        // borderBottom: "none",
      }}
    />
  );
};

export default MyLines;
